export default __webpack_public_path__ + "static/media/icon_peruskriteerit_aloitettu.7d19da3b.svg";